/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'Delete': {
    width: 12,
    height: 13,
    viewBox: '0 0 12 13',
    data: '<path pid="0" fill-rule="evenodd" clip-rule="evenodd" d="M11.237 2.108a.47.47 0 01.463.477v.247c0 .26-.21.477-.463.477H.464A.474.474 0 010 2.832v-.247a.47.47 0 01.464-.477h1.895c.385 0 .72-.274.807-.66l.1-.443C3.418.4 3.926 0 4.507 0h2.684C7.767 0 8.28.401 8.43.973l.106.475c.086.386.42.66.806.66h1.896zm-.963 9.03c.198-1.845.544-6.226.544-6.27a.484.484 0 00-.117-.363.472.472 0 00-.34-.152H1.344a.46.46 0 00-.34.152.514.514 0 00-.124.363l.034.42c.092 1.147.35 4.339.515 5.85.118 1.112.848 1.811 1.906 1.837.816.019 1.657.025 2.516.025.81 0 1.633-.006 2.474-.025 1.094-.02 1.824-.706 1.948-1.838z" _fill="#fff"/>'
  }
})
